import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

// tslint:disable:max-classes-per-file

@Entity({one: "tag", many: "tags"})
export class Tag {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}

@Entity({one: "tag", many: "tagListBundleTagsUser"})
export class BundleTag {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/tags/entities/Tag.ts